export const escapeKeyDown = (key: string) => {
  switch (key) {
    case "Escape":
      return true
    default:
      return false
  }
}
